<template>
  <v-card>
    <v-card-title>Sample Status</v-card-title>
    <v-card-subtitle>Sample #{{ value.id }}</v-card-subtitle>
    <v-container>
      <StepIndicator
        :steps="sample_statuses.filter(item => item.id < 11)"
        :currentStatusId="getCurrentStatus(value.sample_status_id)"
        :currentStatusTitle="
          sample_statuses.find(
            item => item.id == getCurrentStatus(value.sample_status_id)
          ).title
        "
        :sampleStatus="true"
        v-on:close-dialog="() => close()"
        :notes="this.notes"
      />
    </v-container>
  </v-card>
</template>
<script>
import StepIndicator from "@/components/indicators/StepIndicator";
import { mapActions } from "vuex";

export default {
  name: "SamplesStatus",
  components: { StepIndicator },
  props: ["value", "sample_statuses", "notes"],
  data() {
    return {
      loading: false,
      current_status_id: 1
    };
  },
  methods: {
    ...mapActions("baseData", ["getSampleStatuses"]),
    getCurrentStatus(status) {
      let current_status = this.sample_statuses.find(o => o.id === status);
      if (current_status) {
        return current_status.id;
      }
    },
    close() {
      this.$emit("close-dialog");
    }
  },
  mounted() {
    this.loading = true;
  }
};
</script>
